import { render, staticRenderFns } from "./DocumentoAnexoProcesso.vue?vue&type=template&id=fa6a6f34&"
import script from "./DocumentoAnexoProcesso.vue?vue&type=script&lang=js&"
export * from "./DocumentoAnexoProcesso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DocumentoAnexoProcesso.vue"
export default component.exports